export const defaultSalePlan = 25000;
export const defaultCurrencyId = 2;
export const version = '1.5.5-beta';